import store from '@/store'
import axios from 'axios'
// axios.defaults.withCredentials = true
const req_url = store.state.req_url

// 元数据
let getMeta =  (data, cb) => axios_req('post','/dg/getmeta', data, cb)// 按需获取元数据
// 专题
let recommendTheme =  (data, cb) => axios_req('post','/dg/recommendthemelist', data, cb)// 推荐专题列表
let themeList =  (data, cb) => axios_req('post','/dg/themelist', data, cb)// 专题列表，除去推荐的
let themeInfo =  (data, cb) => axios_req('post','/dg/themeinfo', data, cb)// 获取动脉橙专题的基本信息+模块名
let themeModule =  (data, cb) => axios_req('post','/dg/thememodule', data, cb)// 获取专题下模块的内容
let themeNewsTopic =  (data, cb) => axios_req('post','/dg/themenewstopic', data, cb)// 获取专题下面的所有快讯
let addPuv =  (data, cb) => axios_req('post','/dg/addpuv', data, cb)// 添加点击量
let wxShare = (data, cb) => axios_req('post','/dg/shareneedinfo', data, cb) // 分享
let previewTheme =  (data, cb) => axios_req('post','/dg/previewtheme', data, cb)// 主题预览
let getTimeLine =  (data, cb) => axios_req('post','/dg/gettimeline', data, cb)// 获取时间轴
let themeModulContentAll =  (data, cb) => axios_req('post','/dg/thememodulcontentall', data, cb)// 专题首次全部加载
let getMapById =  (data, cb) => axios_req('post','/dg/getmapbyid', data, cb)// 根据id获取图谱数据接口
let getTableById =  (data, cb) => axios_req('post','/dg/gettablebyid', data, cb)// 根据图谱id获取表格数据
let tctEntityList =  (data, cb) => axios_req('post','/dg/tctentitylist', data, cb)// 专题详情--实体对比投融资列表
let policyAnnotation =  (data, cb) => axios_req('post','/dg/policyannotation', data, cb)// 政策要点列表
let getTctData =  (data, cb) => axios_req('post','/dg/gettctdata', data, cb)// 政策要点列表
let getRelevantTheme =  (data, cb) => axios_req('post','/dg/getrelevanttheme', data, cb)// “猜你喜欢”列表

// 简报
let customReportDetail =  (data, cb) => axios_req('post','/dg/customreportdetail', data, cb)// 简报详情接口
let chapterDetail =  (data, cb) => axios_req('post','/dg/chapterdetail', data, cb)// 简报期刊详情接口
let chapterModuleContent =  (data, cb) => axios_req('post','/dg/chaptermodulecontent', data, cb)// 简报-期刊-模块-内容
let previewReport = (data, cb) => axios_req('post','/dg/previewreport', data, cb)// 简报-期刊-模块-内容

// 政策
let policyDetail =  (data, cb) => axios_req('post','/dg/policydetail', data, cb)// 政策详情

// 用户和支付
let loginOut =  (data, cb) => axios_req('post','/dg/loginout', data, cb)// 退出登录
let updateUserInfo =  (data, cb) => axios_req('post','/dg/updateuserinfo', data, cb)//  更新用户信息
let loginOnPhone =  (data, cb) => axios_req('post','/dg/loginonphone', data, cb)// 手机登录
let checkTel =  (data, cb) => axios_req('post','/dg/checktel', data, cb)// 手机号查重
let sendCode =  (data, cb) => axios_req('post','/dg/sendcode', data, cb)// 验证码
let loginOnWx =  (data, cb) => axios_req('post','/dg/loginonwx', data, cb)// 微信登录
let regMobile =  (data, cb) => axios_req('post','/dg/regmobile', data, cb)//  手机号注册用户、忘记密码
let checkMobileReg =  (data, cb) => axios_req('post','/dg/checkmobilereg', data, cb)//  用户注册/绑定时，检查电话号码是否被注册
let bindMobile =  (data, cb) => axios_req('post','/dg/bindMobile', data, cb)//  微信用户绑定手机号
let refreshUserInfo =  (data, cb) => axios_req('post','/dg/refreshuserinfo', data, cb)//  刷新用户信息
let createThemeTypeOrder =  (data, cb) => axios_req('post','/dg/createthemetypeorder', data, cb)//  创建专题类型订单
let createThemeTypePayUrl =  (data, cb) => axios_req('post','/dg/createthemetypepayurl', data, cb)//  生成专题类型支付链接
let orderDetail =  (data, cb) => axios_req('post','/dg/orderdetail', data, cb)//  订单详情
let getUserPayThemeType =  (data, cb) => axios_req('post','/dg/getuserpaythemetype', data, cb)//  获取用户已购专题类型
// 赠送vip服务
let checkVipGiveEffectiveness =  (data, cb) => axios_req('post','/dg/checkvipgiveeffectiveness', data, cb)//  检查赠送数据的真实性并获取剩余数量
let receiveVipGive =  (data, cb) => axios_req('post','/dg/receivevipgive', data, cb)//  提交领取赠送活动
//生成小程序码
let getdgxcxcode =  (data, cb) => axios_req('post','/dg/getdgxcxcode', data, cb)//  生成小程序码

let addTryApply = (data,cb) => axios_req('post','/dg/addtryapply', data, cb)// 申请试用
let axios_req = async(type='get', url = '', data = {}, cb) => {
	let res
	let config = {
		 headers:{'content-Type': 'application/json; charset=UTF-8'}
	}
	if (type=='get') {
		await axios.get(req_url + url).then(response =>{ res = response})
			          .catch(error => {
									cb(error)
								})
	}else{
		await axios.post(req_url + url, JSON.stringify(data), config).then(response =>{
							res = response
					}).catch(error => {
						cb(error)
					})
	}
	// if (res.data.code == 1003) {
	// 	return await res.data
	// }
	return await res.data
}

export {
	getMeta,
  recommendTheme, themeList, themeInfo, themeModule, themeNewsTopic, addPuv, wxShare, previewTheme, getTimeLine, themeModulContentAll, getMapById, getTableById,
	tctEntityList, policyAnnotation, getTctData, getRelevantTheme,
  customReportDetail, chapterDetail, chapterModuleContent, previewReport,
	policyDetail,
	loginOut, updateUserInfo,loginOnPhone, sendCode, loginOnWx, checkTel, regMobile, checkMobileReg, bindMobile, refreshUserInfo,
	createThemeTypeOrder, createThemeTypePayUrl, orderDetail, getUserPayThemeType,
	checkVipGiveEffectiveness, receiveVipGive,
	getdgxcxcode,
	addTryApply
}
